import { api } from 'services/api'

export const getContratosLista = async (idCliente) => {
  let url = `contratos/listarContratosClientes/${idCliente}`

  const response = await api.get(url)

  return response.data.data
}
